import { get } from 'common';

const SLIDER_ROUTE = `${process.env.REACT_APP_API_CONFIG}sliders`;


export class SliderService {
    private static instance: SliderService;

    static getInstance(): SliderService {
        if (!this.instance) {
            this.instance = new SliderService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${SLIDER_ROUTE}`);
    }
}
